import router from '@/router'

import * as firebase from '@/services/firebase'
import * as jwt from '@/services/jwt'

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    register: firebase.register,
    currentAccount: firebase.currentAccount,
    logout: firebase.logout,
  },
  jwt: {
    login: jwt.login,
    google: jwt.google,
    register: jwt.register,
    validateToken: jwt.validateToken,
    logout: jwt.logout,
  },
}

export default {
  namespaced: true,
  state: {
    businessUnit: null,
    email: '',
    id: '',
    loginPlatform: '',
    name: '',
    recordStatus: false,
    role: '',
    truckCode: '',
    loading: false,
    accountFetchIsTouched: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async GOOGLELOGIN({ commit, rootState }, { payload }) {
      const id_token = payload
      commit('SET_STATE', { loading: true })
      try {
        const googleLogin = mapAuthProviders[rootState.settings.authProvider].google
        const response = await googleLogin(id_token)
        if (response) {
          const { email, id, name, role, loginPlatform, recordStatus, truckCode, businessUnit } = response
          commit('SET_STATE', {
            businessUnit,
            email,
            id,
            loginPlatform,
            name,
            recordStatus,
            role,
            truckCode,
            authorized: true,
            loading: false,
          })
          router.push('/inicio')
          return response
        } else {
          commit('SET_STATE', { loading: false })
          throw new Error('No se pudo iniciar sesión con Google')
        }
      } catch (e) {
        commit('SET_STATE', { loading: false })
        throw e
      }
    },

    async LOGIN({ commit, rootState }, { payload }) {
      const { email, password } = payload
      commit('SET_STATE', { loading: true })
      try {
        const login = mapAuthProviders[rootState.settings.authProvider].login
        const response = await login(email, password)
        if (response) {
          const { email: uEmail, id, name, role, loginPlatform, recordStatus, truckCode, businessUnit, token } = response
          if (token) localStorage.xToken = token
          commit('SET_STATE', {
            businessUnit,
            email: uEmail,
            id,
            loginPlatform,
            name,
            recordStatus,
            role,
            truckCode,
            authorized: true,
            loading: false,
          })
          router.push('/inicio')
          return response
        } else {
          commit('SET_STATE', { loading: false })
          throw new Error('Credenciales inválidas')
        }
      } catch (e) {
        commit('SET_STATE', { loading: false })
        throw e
      }
    },
    REGISTER({ commit, rootState }, { payload }) {
      const { email, password, name } = payload
      commit('SET_STATE', { loading: true })
      const register = mapAuthProviders[rootState.settings.authProvider].register

      return register(email, password, name)
        .then(response => {
          // If the backend returns the created user:
          const { businessUnit, loginPlatform, recordStatus, role, truckCode, id, name: rName, email: rEmail } = response || {}
          commit('SET_STATE', {
            businessUnit: businessUnit || null,
            email: rEmail || email,
            id: id || '',
            loginPlatform: loginPlatform || '',
            name: rName || name,
            recordStatus: !!recordStatus,
            role: role || '',
            truckCode: truckCode || '',
            authorized: true,
            loading: false,
          })
          // It shows a notification in Spanish (according to our UI library)
          // notification.success({ message: '¡Registro exitoso!', description: 'El usuario ha sido creado.' })
          return response
        })
        .catch(err => {
          // notification.error({ message: 'Error al registrar', description: err.message })
          commit('SET_STATE', { loading: false })
          throw err
        })
    },
    LOGOUT({ commit, rootState }) {
      const logout = mapAuthProviders[rootState.settings.authProvider].logout
      logout().then(() => {
        commit('SET_STATE', {
          businessUnit: null,
          email: '',
          id: '',
          loginPlatform: '',
          name: '',
          recordStatus: false,
          role: '',
          truckCode: '',
          loading: false,
          accountFetchIsTouched: false,
        })
        localStorage.xToken = ''
        router.push('/auth/login')
      })
    },
    async LOAD_ACCOUNT_FROM_TOKEN({ commit, rootState }) {
      const validateToken = mapAuthProviders[rootState.settings.authProvider].validateToken
      try {
        const response = await validateToken()
        const { isValidToken } = response
        if (isValidToken) {
          const { email, id, name, role, loginPlatform, recordStatus, truckCode, businessUnit } = response
          commit('SET_STATE', {
            businessUnit,
            email,
            id,
            loginPlatform,
            name,
            recordStatus,
            role,
            truckCode,
            authorized: true,
            loading: false,
          })
        } else {
          commit('SET_STATE', { loading: false })
        }
      } catch (error) {
        console.warn(error)
        commit('SET_STATE', { loading: false })
      }
    },
  },
  getters: {
    user: state => state,
  },
}
